// extracted by mini-css-extract-plugin
export default {"dividerLoader":"expenses-list_dividerLoader__Y8vPR"};